import { loadMarketSymbols, loadMarketKlines } from './market_proxy_client';
import { createExchangeWs } from './exchange_ws_base';

export default {
    symbols: [],

    async loadExchangeInfo() {
        this.symbols = await loadMarketSymbols('okx');
        return this.symbols;
    },
    async loadKline(symbol, tf, endTime) {
        return loadMarketKlines('okx', symbol, tf, endTime);
    },

    // OKX closes the connection after ~30s of silence, so a literal "ping"
    // text frame (not JSON) must be sent periodically; it replies "pong".
    ...createExchangeWs({
        wsUrl: 'wss://ws.okx.com:8443/ws/v5/public',
        buildSubscribe: symbols => JSON.stringify({ op: 'subscribe', args: symbols.map(instId => ({ channel: 'tickers', instId })) }),
        buildUnsubscribe: symbols => JSON.stringify({ op: 'unsubscribe', args: symbols.map(instId => ({ channel: 'tickers', instId })) }),
        pingMessage: 'ping',
    }),
};
